import React, { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import arbitrageIcon from "../assets/images/arbitrage.svg";
import newStatus from "../assets/icons/new_status_tag.svg";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { ArbitrageHistory } from "./ArbitrageHistory";
import { InvestmentCarousel } from "./InvestmentCarousel";
import { ArrowLeft } from "lucide-react";
import { Button } from "./ui/button";
import { Separator } from "./ui/separator";
import info from "../assets/icons/info_icon.svg";
import padlock from "../assets/icons/padlock.svg";
import securedBy80eight from "../assets/images/logoSmallGrey.svg";
import investGraphic from "../assets/images/invest/invest_complete.svg";

export default function InvestWithdrawDepositComplete({
  setPageNo,
  type,
  setShowComplete,
}) {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState(null);
  const [open1, setIsOpen1] = useState(true);
  const [open2, setIsOpen2] = useState(false);
  const [open3, setIsOpen3] = useState(false);

  return (
    <div className="col-span-4 px-8">
      <div className="py-5 mb-2">
        <CardContent className="px-20 pb-8 outline outline-gray-50 rounded-lg outline-1">
          <div className="flex items-center justify-center">
            <div className="flex-col">
              <div className="flex justify-center mb-5">
                <img src={investGraphic} alt="" />
              </div>
              <div className="text-center mb-5">
                <h7 className="text-[32px] leading-[40px] text-brand-primary font-semibold">
                  You've made a <br />
                  {type === "deposit" ? "Depsit" : "Withdawal"}
                </h7>
              </div>
              <div className="text-center">
                <p className="font-normal text-[20px] text-text-primary">
                  Funds are now available in your <br />{" "}
                  <span className="font-semibold">Investment</span>
                </p>
              </div>
            </div>
          </div>
          <div className="flex justify-center items-center  mt-5 py-6">
            <Button
              className="py-4 px-[150px] h-15 bg-gradient-to-tr from-purple-500 to-rose-500 text-white rounded-full font-bold"
              onClick={() => {
                setPageNo(0);
                setShowComplete(false);
              }}
            >
              Done
            </Button>
          </div>
        </CardContent>
      </div>
    </div>
  );
}
